import { checkStarsFeedback } from './checkStarsFeedback';
import { resetFeedbackStorage } from './resetFeedbackStorage';
import { sendFeedback } from './sendFeedback';

export default {
  sendFeedback,
  checkStarsFeedback,
  resetFeedbackStorage,
};
